<template>
  <div>
    <Form v-if="formtype === 'simple'" />
    <Anniversary v-if="formtype === 'anniversary'" />
    <AdvancedForm v-if="formtype === 'advanced'" />
    <AdvancedOnlineForm v-if="formtype === 'advanced-online'" />
    <SignupFormSelection v-if="formtype === 'signup' && typeof $route.params.event === 'undefined'" />
    <ExtendedFormSelection v-if="formtype === 'extended' && typeof $route.params.event === 'undefined'" />

    <router-view></router-view>
    <template v-if="formtype === 'signup'">
    </template>
  </div>
</template>

<script>
import Form from '../components/Form.vue'
import Anniversary from '../components/Anniversary.vue'
import AdvancedForm from '../components/AdvancedForm.vue'
import SignupFormSelection from '../components/SignupFormSelection'
import AdvancedOnlineForm from '../components/AdvancedOnlineForm.vue'
import ExtendedFormSelection from '../components/ExtendedFormSelection'

export default {
  name: 'app',
  components: {
    Form,
    Anniversary,
    AdvancedForm,
    AdvancedOnlineForm,
    SignupFormSelection,
    ExtendedFormSelection
  },
  computed: {
    formtype () {
      return this.$store.state.formtype
    }
  }
}
</script>

<style>

</style>
